import axios from 'axios';

const CLIENT_ERROR_PATH = '/api/logs/client-error';

function safePost(url, message) {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
  const body = { url: url || pageUrl, message: String(message || 'Unknown error').slice(0, 8000) };
  return axios
    .post(CLIENT_ERROR_PATH, body, {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      validateStatus: () => true,
    })
    .catch(() => {});
}

/**
 * Register global client-side error reporting (axios 5xx + window errors).
 * Call once at app startup. Skips re-posting when the failing request is the log endpoint itself.
 */
export function setupClientErrorReporting() {
  if (typeof window === 'undefined') return;

  axios.interceptors.response.use(
    (r) => r,
    (err) => {
      const cfg = err.config || {};
      const reqUrl = String(cfg.url || '');
      if (reqUrl.includes(CLIENT_ERROR_PATH)) return Promise.reject(err);
      const status = err.response?.status;
      if (status >= 500) {
        const msg =
          err.response?.data?.error || err.response?.data?.message || err.message || 'Request failed';
        safePost(window.location.href, `HTTP ${status}: ${reqUrl} — ${msg}`);
      }
      return Promise.reject(err);
    }
  );

  window.addEventListener('error', (ev) => {
    const msg = ev.error?.stack || ev.message || 'window.onerror';
    safePost(window.location.href, msg);
  });

  window.addEventListener('unhandledrejection', (ev) => {
    const r = ev.reason;
    const msg = r && typeof r === 'object' && r.message ? r.message : String(r);
    safePost(window.location.href, `Unhandled rejection: ${msg}`);
  });
}
